var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.getViewerComponent,{tag:"component",attrs:{"file":_vm.file,"attributes":_vm.attributes,"getMediaUrl":_vm.getMediaUrlById,"getMedia":_vm.getMedia}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }